/** @jsx jsx */
import React from 'react';
import PropTypes from 'prop-types';
import { jsx } from '@emotion/core';
import styled from '@emotion/styled';
import Row from './Row';
import Column from './Column';
import { ContainersWidth, GridConfig } from './GridSizes';
import MediaQueries from './MediaQueries';

const Container = styled.div({
  width: '100%',
  position: 'relative',
  marginRight: 'auto',
  marginLeft: 'auto',
  [MediaQueries.sm]: {
    width: ContainersWidth.sm,
  },
  [MediaQueries.md]: {
    width: ContainersWidth.md,
  },
  [MediaQueries.lg]: {
    width: ContainersWidth.lg,
  },
  [MediaQueries.xl]: {
    width: ContainersWidth.xl,
    maxWidth: 1440,
  },
});

const ColumnForMd = styled(Column)({
  [MediaQueries.sm]: {
    display: 'none',
  },
});

const ColumnForLg = styled(Column)({
  [MediaQueries.sm]: {
    display: 'none',
  },
  [MediaQueries.md]: {
    display: 'none',
  },
});

const RowWrapper = styled(Row)({
  position: 'absolute',
  top: 0,
  height: '100%',
  left: 0,
  zIndex: 2,
  pointerEvents: 'none',
  width: `calc(100% + ${GridConfig.sm.gutter}px)`,
  [MediaQueries.md]: {
    width: `calc(100% + ${GridConfig.md.gutter}px)`,
  },
  [MediaQueries.lg]: {
    width: `calc(100% + ${GridConfig.lg.gutter}px)`,
  },
  [MediaQueries.xl]: {
    width: `calc(100% + ${GridConfig.xl.gutter}px)`,
  },
});

const Bar = styled.div({
  height: '100%',
  backgroundColor: 'rgba(206, 255, 255, 0.7)',
});

class GridContainer extends React.Component {
  columnConfig = { xl: 1, lg: 1, md: 1, sm: 1 };

  static propTypes = {
    css: PropTypes.string,
    showGrid: PropTypes.bool,
  };

  renderShowGrid = () => {
    const { columnConfig } = this;
    const positions = Array.from(Array(GridConfig.xl.columns).keys());
    const renderColumns = positions.map((_item, index) => {
      const columnNumber = index + 1;
      let ColumnComponent = ColumnForLg;

      if (columnNumber <= GridConfig.sm.columns) {
        ColumnComponent = Column;
      } else if (columnNumber <= GridConfig.md.columns) {
        ColumnComponent = ColumnForMd;
      }

      return (
        <ColumnComponent
          key={`grid-column-${columnNumber}`}
          cols={columnConfig}
        >
          <Bar />
        </ColumnComponent>
      );
    });

    return <RowWrapper className="grid-row">{renderColumns}</RowWrapper>;
  };

  render() {
    const { showGrid, className } = this.props;

    return (
      <Container css={className}>
        {showGrid && this.renderShowGrid()}
        {this.props.children}
      </Container>
    );
  }
}

export default GridContainer;
